import { Redirect } from 'react-router-dom';

//
// Redirects for app URLs that other places still hold: bookmarks, mail, the Teams and Outlook apps.
// Each entry names the route that answers for such a URL. They live together here, so a scene that
// moves leaves its trail in one place instead of in the middle of the route list.
//
// This returns an array of elements, not a component. A Switch reads path or from on each of its own
// children to find the first match; a component holding the redirects has neither, so the Switch
// would take it for every location and fire the first redirect inside it.
//
// Order matters twice: the Switch takes the first match, and a Redirect matches from as a prefix. A
// deeper path therefore comes before the shorter one it starts with, and the whole array belongs
// after the routes, so a live route always wins from a path that starts the same way.
//
// search is the query string of the current location, which a Redirect drops unless the target
// carries it. The Switch runs that target through generatePath, which throws on a query string
// holding a colon, a bracket or a star.
//
export const getLegacyRedirects = (search: string): JSX.Element[] => {
  return [
    //
    // Processes, Objectives and KPIs each have a scene of their own; these are the paths they had as
    // pivots of one Organization scene, together with the child parameter that the prefix match
    // covers. Forms are part of Content configuration, and a link to one carries a form id that the
    // KPIs scene reads as a KPI id, so that one leaves the query string behind.
    //
    <Redirect
      key="legacy-organization-forms"
      from="/organization/forms"
      to={`/admin/content/forms${search}`}
    ></Redirect>,
    <Redirect
      key="legacy-organization-processes"
      from="/organization/processes"
      to={`/processes/overview${search}`}
    ></Redirect>,
    <Redirect
      key="legacy-organization-objectives"
      from="/organization/objectives"
      to={`/objectives/overview${search}`}
    ></Redirect>,
    <Redirect key="legacy-organization-kpis" from="/organization/kpis" to={`/kpis/overview${search}`}></Redirect>,
    <Redirect key="legacy-organization" from="/organization" to="/processes/overview"></Redirect>,
  ];
};
